var sony_RM_ED009 = {
    name: "RM_ED009",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,83,100,45,187,196],
        },
        {
            function: "KEY_INFO",
            name: "KEY_INFO",
            icon: "KEY_INFO",
            command: [32,0,4,243,4,8,2,146,2,8,2,178,9,219,1,243,4,229,76,59,181,173,16],
        },
        {
            function: "pic",
            name: "pic",
            icon: "pic",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,235,97,58,181,226],
        },
        {
            function: "ab",
            name: "ab",
            icon: "ab",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,235,97,42,221,226],
        },
        {
            function: "KEY_RED",
            name: "KEY_RED",
            icon: "KEY_RED",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,235,97,58,234,226],
        },
        {
            function: "KEY_GREEN",
            name: "KEY_GREEN",
            icon: "KEY_GREEN",
            command: [26,0,4,252,4,1,2,148,2,1,2,174,9,220,1,148,2,131,95,55,94,162],
        },
        {
            function: "KEY_YELLOW",
            name: "KEY_YELLOW",
            icon: "KEY_YELLOW",
            command: [26,0,4,252,4,1,2,148,2,1,2,174,9,220,1,148,2,131,95,47,94,162],
        },
        {
            function: "KEY_BLUE",
            name: "KEY_BLUE",
            icon: "KEY_BLUE",
            command: [26,0,4,252,4,1,2,148,2,1,2,174,9,220,1,148,2,27,93,62,189,68],
        },
        {
            function: "input",
            name: "input",
            icon: "input",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,83,100,45,219,196],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,235,97,59,85,226],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [26,0,4,252,4,1,2,148,2,1,2,174,9,220,1,148,2,131,95,54,250,162],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,83,100,59,91,196],
        },
        {
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,235,97,45,213,226],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,235,97,43,173,226],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,187,102,63,87,136],
        },
        {
            function: "analog",
            name: "analog",
            icon: "analog",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,83,100,61,91,196],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [26,0,4,148,2,1,2,174,9,220,1,252,4,1,2,148,2,139,107,127,158,32],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,35,105,47,239,16],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,35,105,55,239,16],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,187,102,43,247,136],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,35,105,59,239,16],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,187,102,45,247,136],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,187,102,53,247,136],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,83,100,42,251,196],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,35,105,61,239,16],
        },
        {
            function: "KEY_TEXT",
            name: "KEY_TEXT",
            icon: "KEY_TEXT",
            command: [26,0,4,252,4,1,2,148,2,1,2,174,9,220,1,148,2,27,93,63,181,68],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,187,102,46,247,136],
        },
        {
            function: "refresh",
            name: "refresh",
            icon: "refresh",
            command: [26,0,4,252,4,1,2,148,2,1,2,174,9,220,1,148,2,131,95,59,218,162],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,187,102,55,119,136],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,83,100,43,187,196],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,35,105,62,239,16],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,187,102,47,119,136],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [26,0,4,148,2,1,2,252,4,1,2,174,9,220,1,148,2,187,102,59,119,136],
        },
        {
            function: "aspect",
            name: "aspect",
            icon: "aspect",
            command: [32,0,4,243,4,8,2,146,2,8,2,178,9,219,1,243,4,229,76,55,213,173,16],
        },
        {
            function: "KEY_ENTER",
            name: "KEY_ENTER",
            icon: "KEY_ENTER",
            command: [32,0,4,243,4,8,2,146,2,8,2,178,9,219,1,243,4,229,76,58,183,181,16],
        },
        {
            function: "tools",
            name: "tools",
            icon: "tools",
            command: [32,0,4,243,4,8,2,146,2,8,2,178,9,219,1,243,4,132,74,46,239,106,32],
        },
        {
            function: "digital",
            name: "digital",
            icon: "digital",
            command: [32,0,4,243,4,8,2,146,2,8,2,178,9,219,1,146,2,132,74,45,111,188,64],
        },
        {
            function: "theatre",
            name: "theatre",
            icon: "theatre",
            command: [32,0,4,243,4,8,2,146,2,8,2,178,9,219,1,146,2,229,76,42,175,222,32],
        },
    ]
}
export default sony_RM_ED009